import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';

// 外部連結(給客戶)
import Customer from '@/views/Customer/index';
import Home from '@/views/Home';
import CustomerView from '@/views/Customer/View';
import Outline from '@/views/Customer/Outline';

Vue.use(Router);

// @const {Object} internalLinkName 內部連結名稱
const { internalLinkName } = store.getters['enumList/getEnum'];

const router = new Router({
  mode: 'history',
  base: process.env.API_SUFFIX ? `/customer${process.env.API_SUFFIX}/` : '/customer/',
  routes: [
    // 檢視檔案 (外部連結進入)
    {
      path: '/',
      component: Customer,
      meta: {
        showOnSidebar: false,
        root: internalLinkName.CUSTOMER.ROOT,
      },
      children: [
        {
          path: '',
          component: Home,
          name: internalLinkName.CUSTOMER.ROOT,
          meta: {
            showOnSidebar: false,
            requiresAuth: false,
          },
        },
        {
          path: 'view',
          component: CustomerView,
          name: internalLinkName.CUSTOMER.subNode.VIEW,
          meta: {
            showOnSidebar: false,
            requiresAuth: false,
          },
        },
        {
          path: 'outline',
          component: Outline,
          name: internalLinkName.CUSTOMER.subNode.OUTLINE,
          meta: {
            showOnSidebar: false,
            requiresAuth: false,
          },
        },
        {
          path: 'outline/:sid',
          redirect: (to) => ({ path: 'outline', query: { sid: to.params.sid } }),
        },
        {
          path: '/*',
          redirect: '/',
        },
      ],
    },
  ],
});

export default router;
